import { FileWarning } from "lucide-react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import {
  AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent,
  AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle,
  AlertDialogTrigger,
} from "@/components/ui/alert-dialog";
import { buttonVariants } from "@/components/ui/button-variants";

/**
 * SPEC-FRONT-SHELL-01 S4: the deliberate reload is the primary action and
 * "Ir para Hoje" (the existing `/` destination) the secondary one; navigating
 * there leaves the failed boundary. Nothing reloads on its own.
 */
export function ChunkRecovery({ todayAction = true }: { todayAction?: boolean }) {
  return <section className="mx-auto flex min-h-64 max-w-lg flex-col items-center justify-center gap-5 px-6 py-10 text-center">
    <span className="rounded-full bg-accent-warm-soft p-3 text-petrol" aria-hidden="true">
      <FileWarning className="size-6" />
    </span>
    <div className="space-y-3" role="alert">
      <h1 className="font-display text-2xl text-app-fg-strong">Não foi possível abrir esta página</h1>
      <p className="text-sm text-app-fg">
        Isso pode acontecer por uma falha de conexão ou uma atualização do aplicativo.
        Você pode acessar outra página pelo menu ou recarregar esta aba.
      </p>
    </div>
    <div className="flex flex-wrap items-center justify-center gap-2">
      <AlertDialog>
        <AlertDialogTrigger asChild>
          <Button variant="petrol" className="min-h-11">Recarregar página</Button>
        </AlertDialogTrigger>
        <AlertDialogContent className="max-w-[calc(100%-2rem)] rounded-xl border-app-border bg-app-surface sm:max-w-lg">
          <AlertDialogHeader>
            <AlertDialogTitle className="font-display text-xl text-app-fg-strong">Recarregar esta página?</AlertDialogTitle>
            <AlertDialogDescription className="text-app-fg">
              Alterações não salvas nesta aba podem ser perdidas. Se houver algo em edição,
              continue nesta página e salve ou copie seu trabalho antes de recarregar.
            </AlertDialogDescription>
          </AlertDialogHeader>
          <AlertDialogFooter className="gap-2">
            <AlertDialogCancel className="min-h-11">Continuar nesta página</AlertDialogCancel>
            <AlertDialogAction className={buttonVariants({ variant: "petrol", className: "min-h-11" })} onClick={() => window.location.reload()}>
              Recarregar agora
            </AlertDialogAction>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>
      {todayAction && (
        <Link to="/" className={buttonVariants({ variant: "outline", className: "min-h-11" })}>
          Ir para Hoje
        </Link>
      )}
    </div>
  </section>;
}
